import React, { useState, useEffect } from 'react';
import { Lesson } from '../types';
import { useNavigate } from 'react-router-dom';
import { config } from '../config/config';

const ScheduleEditor: React.FC = () => {
  const [lessons, setLessons] = useState<Lesson[]>([]);
  const [newLesson, setNewLesson] = useState<Lesson>({ time: '', name: '', link: '', image: '', day:"ראשון", status:"active" });
  const [selectedLesson, setSelectedLesson] = useState<Lesson | null>(null);
  const [selectedDay, setSelectedDay] = useState<string>('ראשןם'); 
  const navigate = useNavigate();
  
  const daysOfWeek = ['ראשון', 'שני', 'שלישי', 'רביעי', 'חמישי']; 

  useEffect(()=>{
    setNewLesson({...newLesson, day: selectedDay});
  },[selectedDay])

  useEffect(() => {
    const token = localStorage.getItem('jwtToken');
    fetch(config.apiUrl+'/lessons')
      .then(res => res.json())
      .then(data => setLessons(data))
      .catch(err => console.error('Error fetching lessons:', err));
  }, []);

  const handleAddLesson = () => {
    const token = localStorage.getItem('jwtToken');
    fetch(config.apiUrl+'/lessons', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
      body: JSON.stringify(newLesson),
    })
      .then(() => {
        setLessons([...lessons, newLesson]);
        setNewLesson({ time: '', name: '', link: '', image: '', day:"ראשון", status:"active" });
        window.location.reload();
      })
      .catch(err => console.error('Error adding lesson:', err));
    };
    
    const handleUpdateLesson = () => {
      const token = localStorage.getItem('jwtToken');
      if (!selectedLesson) return;
      
      fetch(config.apiUrl+`/lessons/${selectedLesson.id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify(selectedLesson),
      })
      .then(() => {
        setLessons(lessons?.map(lesson => (lesson.id === selectedLesson.id ? selectedLesson : lesson)));
        setSelectedLesson(null);
        window.location.reload();
      })
      .catch(err => console.error('Error updating lesson:', err));
    };
    
    const handleDeleteLesson = (id?: number) => {
      if (id) {
        const token = localStorage.getItem('jwtToken');
        fetch(config.apiUrl+`/lessons/${id}`, {
          method: 'DELETE',
          headers: { 'Authorization': `Bearer ${token}` },
        })
        .then(() => {
          setLessons(lessons.filter(lesson => lesson.id !== id));
        })
        .catch(err => console.error('Error deleting lesson:', err));
      }
    };
    
    const handleLogout = async () => {
      try {
        localStorage.removeItem('jwtToken'); 
        navigate('/'); 
      } catch (error) {
        console.error('Error signing out:', error);
      }
    };
    
    return (
    <div className='page'>
    <h1>עורך מערכת השעות</h1>
    <button className="logout-button" onClick={handleLogout}>התנתק</button> 

    <div>
        <h2>הוסף שיעור חדש</h2>
        <input
            type="text"
            placeholder="שם שיעור"
            value={newLesson.name}
            onChange={(e) => setNewLesson({ ...newLesson, name: e.target.value })}
        />
        <input
            type="time"
            step="3600000"
            value={newLesson.time}
            onChange={(e) => setNewLesson({ ...newLesson, time: e.target.value })}
        />
        <input
            type="url"
            placeholder="קישור"
            value={newLesson.link}
            onChange={(e) => setNewLesson({ ...newLesson, link: e.target.value })}
        />
        <select value={selectedDay} onChange={(e) => setSelectedDay(e.target.value)}>
            {daysOfWeek.map(day => (
                <option key={day} value={day}>
                    {day}
                </option>
            ))}
        </select>
        <button onClick={handleAddLesson}>הוסף שיעור</button>
    </div>

    <div>
        <h2>ערוך שיעורים</h2>
        <select onChange={(e) => setSelectedLesson(lessons.find(lesson => lesson.id === Number(e.target.value)) || null)}>
            <option value="">בחר שיעור לערוך</option>
            {lessons?.map(lesson => (
                <option key={lesson.id} value={lesson.id}>
                    {lesson.name} ({lesson.time})
                </option>
            ))}
        </select>

        {selectedLesson && (
            <div className="lesson-edit">
                <input
                    type="text"
                    placeholder="Lesson Name"
                    value={selectedLesson.name}
                    onChange={(e) => setSelectedLesson({ ...selectedLesson, name: e.target.value })}
                />
                <input
                    type="time"
                    step="3600000"
                    value={selectedLesson.time}
                    onChange={(e) => setSelectedLesson({ ...selectedLesson, time: e.target.value })}
                />
                <input
                    type="url"
                    placeholder="Link"
                    value={selectedLesson.link}
                    onChange={(e) => setSelectedLesson({ ...selectedLesson, link: e.target.value })}
                />
                <select value={selectedDay} onChange={(e) => setSelectedDay(e.target.value)}>
                    {daysOfWeek.map(day => (
                        <option key={day} value={day}>
                            {day}
                        </option>
                    ))}
                </select>
                <button onClick={handleUpdateLesson}>Update Lesson</button>
                <button onClick={() => handleDeleteLesson(selectedLesson.id)}>מחק שיעור</button>
            </div>
        )}
    </div>
</div>
  );
};

export default ScheduleEditor;